
import VisibleOptions from "@/components/widgets/VisibleOptions.vue";
import Vue from "vue";
import { Prop, Component, Watch, PropSync } from "vue-property-decorator";

@Component({
  components: {
    VisibleOptions
  }
})
export default class NotesFields extends Vue {
  localNote = {};

  @Prop({ default: { text: "", visibleOption: "0", customerViewable: true, facilityViewable: true } })
  note: Object;

  @Prop({ default: false })
  hideVisibleTo: boolean;

  @Prop({ default: false })
  required: boolean;

  @Prop({ default: false })
  hasRequiredNoteError: boolean;

  mounted() {
    this.localNote = this.note;
  }
  changeNoteVisibleTo(value) {
    this.localNote = { ...this.localNote, ...value };
    this.publishChange();
  }
  publishChange() {
    this.$emit("updated", this.localNote);
  }
}
